import { computed, type Ref } from 'vue'
import type { OccasionFeedItem } from '#root/types/occasions'

export function useOccasionHrefs(
  occasion: Ref<OccasionFeedItem | null | undefined>,
  canonicalPaths: { base: string },
  registerParams?: Ref<[string, string][] | undefined>
) {
  const infoHref = computed(() => {
    const product = occasion.value?.product_variant?.product
    if (!product || typeof product !== 'object') return ''
    const code = product.occasion_type?.code
    const pageSlug = 'page_slug' in product ? product.page_slug : undefined
    if (!pageSlug) return ''
    switch (code) {
      case 'C':
        return `/training/courses/${pageSlug}`
      case 'W':
        return `/training/workshops/${pageSlug}`
      default:
        return ''
    }
  })

  const registerHref = computed(() => {
    if (!infoHref.value || !occasion.value?.sku) return ''
    const url = new URL(infoHref.value, canonicalPaths.base)
    url.hash = `h${occasion.value.sku}`
    if (registerParams?.value && Array.isArray(registerParams.value)) {
      registerParams.value.forEach(([n, v]) => url.searchParams.set(n, v))
    }
    return url.href
  })

  return {
    infoHref,
    registerHref
  }
}
